import { Navbar, Nav, Container, Row, Col, Carousel } from "react-bootstrap";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import "./App.css";
import AmigosDoLixoMap from "./Mapa.js";
import Graficos from "./Graficos";
import GuiaReciclagem from "./GuiaReciclagem.js";
import TabelaBairros from "./TabelaBairros.js";
import Manual from "./Manual.js";
import HeroSection from "./Hero.js";
import GoogleDriveVideo from "./CardVideo.js";

function App() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="App">
      <Navbar
        expand="lg"
        className="navbar-custom fixed-top"
        expanded={expanded}
      >
        <Container>
          <Navbar.Brand
            href="#home"
            className="text-white d-flex align-items-center"
          >
            <img src="/img/logos.png" width={55} alt="Logo" className="me-2" />
            <span>AMIGOS DO LIXO</span>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : true)}
          >
            <span className="custom-toggler"></span>
            <span className="custom-toggler"></span>
            <span className="custom-toggler"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" onClick={() => setExpanded(false)}>
                Home
              </Nav.Link>
              <Nav.Link href="#history" onClick={() => setExpanded(false)}>
                Nossa História
              </Nav.Link>
              <Nav.Link href="#about" onClick={() => setExpanded(false)}>
                Sobre Nós
              </Nav.Link>
              <Nav.Link href="#mission" onClick={() => setExpanded(false)}>
                Missão e Valores
              </Nav.Link>
              <Nav.Link href="#gallery" onClick={() => setExpanded(false)}>
                Galeria
              </Nav.Link>
              <Nav.Link href="#manual" onClick={() => setExpanded(false)}>
                Manual
              </Nav.Link>
              <Nav.Link href="#contact" onClick={() => setExpanded(false)}>
                Contato
              </Nav.Link>
              <Nav.Link href="#partners" onClick={() => setExpanded(false)}>
                Parceiros
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <HeroSection />

      <section id="history" className="d-block d-md-none py-5  ">
  <div className="container text-center">
    <h2 className="mb-4">Assista Nosso Vídeo</h2>
   <GoogleDriveVideo/>
    <p className="mt-3">Conheça nosso projeto e nosso impacto ambiental!</p>
  </div>
</section>


      <section id="history" className="py-2 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col>
              <h2 className="display-3 fw-bold text-dark mb-4">
                Nossa História
              </h2>
              <p className="lead text-muted">
                O Projeto Amigos do Lixo, de Guaratinguetá, nasceu em julho de
                2000 como uma iniciativa voluntária da sociedade civil,
                preocupada tanto com a preservação ambiental quanto com as
                precárias condições de vida e de trabalho dos catadores de lixo.
                O lema “Preservando a natureza e respeitando o cidadão” traduz
                seu propósito: unir sustentabilidade e inclusão social.
              </p>
              <p className="lead text-muted">
                O projeto identificou e organizou os catadores — que passaram a
                ser reconhecidos como Agentes Ambientais — e implantou um
                programa pioneiro de coleta seletiva, iniciado nos bairros
                Pedregulho e Alto Pedregulho. Com a fundação da Cooperativa
                Amigos do Lixo em 2001, a triagem, prensagem e comercialização
                dos recicláveis se tornaram organizadas e autossustentáveis.
              </p>
              <p className="lead text-muted">
                Mais que um projeto ambiental, o Amigos do Lixo é um exemplo de
                cidadania e transformação social, mostrando que é possível
                “coletar materiais e reciclar vidas”.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="about" className="about-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4">
              <div className="about-content">
                <h2 className="display-5 fw-bold text-dark mb-4">Sobre Nós</h2>
                <p className="lead text-muted mb-4">
                  A Cooperativa Amigos do Lixo é formada por trabalhadores
                  dedicados à coleta, separação e comercialização de materiais
                  recicláveis. Atuamos com compromisso social e ambiental,
                  promovendo a valorização do trabalho dos cooperados e o
                  cuidado com o meio ambiente.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="about-image">
                <img
                  src="/img/grupo.jpg"
                  alt="Equipe AMIGOS DO LIXO"
                  className="img-fluid rounded-3 shadow"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="mission" className="py-5 bg-light">
        <Container>
          <Row>
            <Col>
              <h2 className="display-5 fw-bold text-dark mb-4">Missão</h2>
              <p className="lead text-muted">
                Promover a geração de trabalho e renda por meio da coleta,
                triagem e destinação adequada de resíduos recicláveis,
                contribuindo para a preservação ambiental e a melhoria da
                qualidade de vida dos cooperados e da comunidade.
              </p>

              <h2 className="display-5 fw-bold text-dark mb-4 mt-5">Valores</h2>
              <ul className="lead text-muted">
                <li>
                  <strong>Sustentabilidade</strong> – compromisso com práticas
                  que preservam o meio ambiente.
                </li>
                <li>
                  <strong>Cooperação</strong> – união e trabalho em equipe como
                  base do desenvolvimento.
                </li>
                <li>
                  <strong>Transparência</strong> – relações claras e éticas com
                  cooperados, parceiros e comunidade.
                </li>
                <li>
                  <strong>Responsabilidade Social</strong> – foco na valorização
                  humana e no impacto positivo na sociedade.
                </li>
                <li>
                  <strong>Qualidade</strong> – eficiência e cuidado em todas as
                  etapas do processo de reciclagem.
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="coleta" className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <Carousel>
                {[
                  "/img/coleta1.jpg",
                  "/img/coleta2.jpg",
                  "/img/coleta3.jpg",
                  "/img/coleta4.jpg",
                  "/img/caminhao.jpeg",
                ].map((src, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 rounded shadow-sm"
                      src={src}
                      alt={`Coleta seletiva ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>

            <Col lg={6}>
              <h2 className="display-5 fw-bold text-dark mb-4">
                Coleta Seletiva
              </h2>
              <h4 className="fw-bold text-dark mb-3">O que é?</h4>
              <p className="lead text-muted">
                Coleta seletiva é a ação de recolher separadamente os resíduos
                sólidos recicláveis, previamente separados pelos munícipes, em
                dias, horários e veículos distintos da coleta convencional de
                lixo úmido, com o objetivo de viabilizar sua destinação
                adequada, como a reciclagem ou reutilização.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <GuiaReciclagem />

      <Manual />
      <TabelaBairros />
      <Graficos />

      <section id="gallery" className="gallery-section py-5 bg-light">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-5 fw-bold text-dark mb-3">
                Nossa Galeria
              </h2>
              <p className="lead text-muted">Conheça nosso projeto</p>
            </Col>
          </Row>
          <Row>
            {[
              "/img/grupo.jpg",
              "/img/IMG_3862.jpg",
              "/img/IMG_3867.jpg",
              "/img/IMG_3870.jpg",
              "/img/IMG_3875.jpg",
              "/img/Amigosdolixo1.png",
            ].map((src, index) => (
              <Col key={index} lg={4} md={6} sm={12} className="mb-4">
                <img
                  src={src}
                  alt={`Galeria imagem ${index + 1}`}
                  className="rounded shadow-sm"
                  style={
                    src === "/img/Amigosdolixo1.png"
                      ? {
                          width: "416px",
                          height: "277.33px",
                          objectFit: "contain",
                        }
                      : { width: "100%" }
                  }
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section id="partners" className="partners-section py-5 bg-light">
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h2 className="display-5 fw-bold text-dark">Nossos Parceiros</h2>
              <p className="lead text-muted">
                Trabalhamos junto com parceiros comprometidos com a
                sustentabilidade.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center">
            <Col xs={6} md={3} className="mb-3">
              <img
                src="/img/logobasf.png"
                alt="Parceiro BASF"
                className="img-fluid"
                style={{
                  maxHeight: "200px",
                  margin: "0 auto",
                  display: "block",
                }}
              />
            </Col>
            <Col xs={6} md={3} className="mb-3">
              <img
                src="/img/logosaeg.png"
                alt="Parceiro SAEG"
                className="img-fluid"
                style={{
                  maxHeight: "80px",
                  margin: "0 auto",
                  display: "block",
                }}
              />
            </Col>
            <Col xs={6} md={3} className="mb-3">
              <img
                src="/img/logoprefeitura.PNG"
                alt="Parceiro Prefeitura"
                className="img-fluid"
                style={{
                  maxHeight: "80px",
                  margin: "0 auto",
                  display: "block",
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section id="contact" className="contact-section py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-5 fw-bold text-dark mb-3">
                Entre em Contato
              </h2>
              <p className="lead text-muted">
                Estamos localizados em Guaratinguetá! Veja nosso endereço no
                mapa abaixo:
              </p>
              <p>
                Endereço:Estr. Vicinal Dr. Rafael Américo Ranieri, 999 - Santa
                Luzia, Guaratinguetá - SP
              </p>
              <p>
                Celular: (12)99236-8660 | E-mail:
                amigosdolixoguaratingueta@gmail.com
              </p>
              <AmigosDoLixoMap />
            </Col>
          </Row>
        </Container>
      </section>

      <footer className="footer-section py-4 bg-dark text-white">
        <Container>
          <Row className="text-center">
            <Col>
              <p className="mb-0">© 2025 - Amigos do Lixo</p>
            </Col>
          </Row>
        </Container>
      </footer>

      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />
    </div>
  );
}

export default App;
